import React from "react";

export const TogglerContext = React.createContext({});

export const SelectItemsContext = React.createContext({});
export const SelectItemContext = React.createContext({});
export const WidgetContext = React.createContext({});
